<template>
  <svg width="21" height="21" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10.5" cy="10.5" r="10" fill="none" stroke="#ACACAC" />
    <circle v-show="isSelected" cx="10.5" cy="10.5" r="6.5" fill="#0099FF" stroke="none" />
  </svg>
</template>

<script>
export default {
  props: {
    isSelected: Boolean,
  },
}
</script>
